import styled from "styled-components";

export const Tip = styled.div`
  background-color: rgb(242, 248, 255);
  padding: 1rem;
  margin-top: 1rem;
`;
